module.exports = __webpack_public_path__ + "static/media/onboarding_coursier_step2.5cfb352b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/onboarding/onboarding_coursier_step2.svg
// module id = 1211
// module chunks = 0